import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import ParadigmaEditor from '../../../components/ParadigmaEditor/ParadigmaEditor';

const PlantillaFormSections = ({
    disabled = false,
    descripcion,
    asunto,
    cuerpo,
    onDescripcionChange,
    onAsuntoChange,
    onCuerpoChange,
    autoFocusFirstField = false,
}) => (
    <div className="ui-section-stack">
        <section className="ui-section-block">
            <p className="ui-section-label">Datos de la plantilla</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Descripcion</Label>
                    <Input
                        disabled={disabled}
                        type="text"
                        name="descripcion"
                        autoFocus={autoFocusFirstField}
                        data-auto-focus={autoFocusFirstField ? "true" : null}
                        value={descripcion}
                        onChange={onDescripcionChange} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>

        <section className="ui-section-block">
            <p className="ui-section-label">Mail</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Asunto</Label>
                    <Input
                        disabled={disabled}
                        type="text"
                        name="asunto"
                        value={asunto}
                        onChange={onAsuntoChange} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Cuerpo</Label>
                    <ParadigmaEditor
                        value={cuerpo}
                        onChange={onCuerpoChange}
                        disabled={disabled}
                    />
                </div>
            </div>
        </section>
    </div>
);

export default PlantillaFormSections;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/PlantillaFormSections.js